/**
 * Initializes an Alpine.js data object to manage the product listing page (PLP) carousel using Swiper.
 * Key features include:
 * 1. Responsive Navigation: Configures carousel navigation for a seamless browsing experience.
 * 2. Dynamic Adjustment: Automatically centers items if they do not occupy more space than the carousel's visible area.
 * 3. Swiper Integration: Leverages Swiper for flexible, responsive handling of product slides.
 */

function plpCarousel() {
  return {
    swiper: null,
    init() {
      this.cacheNodes();
      this.buildSwiper();
    },

    swiperCenterOnNoScroll: (swiper) => {
      const isSwipeable = swiper.virtualSize > swiper.size;

      if (!isSwipeable) {
        swiper.wrapperEl?.classList.add('swiper-wrapper-center');
      } else {
        swiper.wrapperEl?.classList.remove('swiper-wrapper-center');
      }
    },

    cacheNodes() {
      this.swiperContainer = document.querySelector('.anatta-collection-carousel');
    },

    buildSwiper() {
      if (this.swiper || !this.swiperContainer) {
        return;
      }
      this.swiper = new Swiper(this.swiperContainer, {
        slidesPerView: 'auto',
        navigation: {
          nextEl: this.swiperContainer.querySelector('.swiper-button-next-collection-carousel'),
          prevEl: this.swiperContainer.querySelector('.swiper-button-prev-collection-carousel'),
        },
        breakpoints: {
          1023: {
            centeredSlides: false,
          },
        },
        on: {
          init: this.swiperCenterOnNoScroll,
          resize: this.swiperCenterOnNoScroll,
        },
      });
    },
  };
}

document.addEventListener('alpine:init', () => {
  Alpine.data('plpCarousel', plpCarousel);
});
